import React from "react";
import { makeStyles, Paper } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  paper: {
    background: "white",
    marginTop: 30,
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    width: "auto",
    height: 140,
  },
}));

const ProductCard = ({ isMovile, children }) => {
  const classes = useStyles();

  return (
    <Paper elevation={5} className={classes.paper}>
      <span
        style={{ fontWeight: 650, color: isMovile ? " #ff8080" : "#00802b" }}
      >
        {" "}
        {isMovile ? "Equipo Móvil" : "Accesorio"}
      </span>
      {children}
    </Paper>
  );
};

export default ProductCard;
